<template>
  <MarketplaceForm :item="item" :default-item-data="item_data" :new-store-fn="newStoreYandex" :edit-store-fn="editStoreYandex" @storeSuccess="$emit('storeSuccess')">
    <template #top>
      <div class="col mb-3">
        <DocLink docKey="marketplace_yandex" text="Посмотреть инструкцию по подключению Яндекс Маркет" />
      </div>
    </template>
    <template #connection="{item_data}">
      <div class="col mb-4">
        <label class="form-label">ID кабинета (Business ID)</label>
        <input type="text" name="connection[business_id]" class="form-control" placeholder="" required
               v-model="item_data.connection.business_id">
      </div>
      <div class="col mb-4">
        <label class="form-label">ID магазина (Campaing ID)</label>
        <input type="text" name="connection[campaign_id]" class="form-control" placeholder="" required
               v-model="item_data.connection.campaign_id">
      </div>
      <div class="col mb-4">
        <label class="form-label">API Key</label>
        <div class="input-group">
          <input :type="apiKeyVisible ? 'text' : 'password'" name="connection[api_key]" class="form-control" placeholder="" required
                 v-model="item_data.connection.api_key">
          <span class="input-group-text cursor-pointer" @click="toggleApiKeyVisibility">
            <i class="ti" :class="apiKeyVisible ? 'ti-eye-off' : 'ti-eye'"></i>
          </span>
        </div>
      </div>
    </template>
  </MarketplaceForm>
</template>
<script>
import {editStoreYandex, newStoreYandex} from "@/api/store";
import MarketplaceForm from "@/components/forms/MarketplaceForm.vue";
import DocLink from "@/components/tools/DocLink.vue";

export default {
  name: "YandexForm",
  components: {MarketplaceForm, DocLink},
  data() {
    return {
      apiKeyVisible: false,
      item_data: {
        id: '',
        name: '',
        company: '',
        marketplace: 'yandex',
        connection: {
          business_id: '',
          campaign_id: '',
          api_key: ''
        },
        settings: {
          model: 'fbs',
          fixed_commission: 10,
          percent_commission: 0,
        },
        schedule: {
          import_products: null,
          get_offers: [4, 16],
          get_orders: '60'
        }
      }
    }
  },
  props: ['item'],
  methods: {
    newStoreYandex, editStoreYandex,
    toggleApiKeyVisibility() {
      this.apiKeyVisible = !this.apiKeyVisible;
    }
  }
}
</script>